import React, { Component } from 'react'
import './index.less'
import { unix2date6 } from 'src/helper/time'
import score from 'src/helper/score'

export default class extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    console.log(1)
    let { language, lang, funcTabBarHis, closeFuncTabBarHis, historyList } = this.props
    return (
      <div
        className={`his-wrap ${language == 'ar' && 'arlang'}`}
        style={{ display: funcTabBarHis == '1' ? 'block' : 'none' }}
      >
        <div className="his-box">
          <div className="close" onClick={() => {
            closeFuncTabBarHis()
          }}></div>
          <div className="title">{lang.history}</div>
          <div className="item-list">
            {historyList &&
              historyList.length > 0 &&
              historyList.map((item, index) => {
                return (
                  <div className="item" key={index}>
                    <div className={`top ${language == 'ar' && 'arlang'}`}>
                      <div className="round">
                        {lang.round} {item.roundId}
                      </div>
                      <div className="time">{unix2date6(item.ts)}</div>
                    </div>
                    <div className={`bottom ${language == 'ar' && 'arlang'}`}>
                      <div className="bo-title">
                        <span>{lang.winfruit}</span>
                        <img
                          style={{ display: item.fruitId == -1 ? 'none' : 'block' }}
                          src={`/img/activity/lottery/${item.fruitId + 1}.png`}
                          alt=""
                        />
                        <div
                          className="tips"
                          style={{ fontSize: '0.2rem', display: item.onlyOne == 1 ? 'block' : 'none' }}
                        >
                          <div dangerouslySetInnerHTML={{
                            __html: lang.invalid.replace('11', item.rewardCoins)
                          }}></div>
                        </div>
                        <div className="questoin" style={{ display: item.fruitId == -1 ? 'block' : 'none' }}>
                          ?
                        </div>
                      </div>

                      <div className="his-table">
                        <div className="his-td">
                          <div className="sel-fruit">{lang.selfruit}</div>
                          <div className="bet">{lang.goldNum}</div>
                          <div className="winer">{lang.gain}</div>
                        </div>

                        {item.betList.map((item2, index) => {
                          return (
                            <div className="his-td" key={index}>
                              <div className="sel-fruit">
                                <img src={`/img/activity/lottery/${item2.wheelId + 1}.png`} alt="" />
                              </div>
                              <div className="bet">
                                <span>{score(item2.coins)}</span>
                                <img src="/img/activity/lottery/jb.png" alt="" />
                              </div>
                              <div className="winer">
                                <span>{item2.wheelId == item.fruitId ? score(item.rewardCoins) : '0'}</span>
                                <img src="/img/activity/lottery/jb.png" alt="" />
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/lottery/History/index.js